import { Grid, Typography } from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as CloseIcon } from 'common/assets/images/close.svg';
import HeatMapScore from 'common/assets/images/riskmodal-static-heatmap-score.png';
import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';
import {
	RISK_COUNT_INFO_DESCRIPTION,
	RISK_COUNT_LABEL,
	RISK_COUNT_MAIN_LABEL,
	RISK_RECENT_ACTIVITY_DESCRIPTION,
	RISK_RECENT_ACTIVITY_LABEL,
	RISK_SCORE_CALCULATION_DESCRIPTION,
	RISK_SCORE_CALCULATION_LABEL,
	RISK_SCORE_GOT_IT_BUTTON,
} from 'common/constants/TaxonomyConstants';
import { RootState } from 'common/store/AppStore';
import { setRiskRefTaxonomyModalFlag } from 'common/store/reducer/taxonomyReducer';

import styles from './RiskModal.module.scss';

const RiskModal = () => {
	const dispatch = useDispatch();
	const riskRefTaxonomyModalFlag = useSelector(
		(state: RootState) => state.taxonomy.riskRefTaxonomyModalFlag,
	);
	/**
	 * Closes the risk modal and updates the risk reference taxonomy modal flag.
	 */
	const handleModalClose = () => {
		dispatch(setRiskRefTaxonomyModalFlag(false));
	};

	return (
		<ModalEle
			open={riskRefTaxonomyModalFlag}
			handleClose={handleModalClose}
			data-testid="risk-modal"
			sxBoxProps={{ width: '40%', height: '60%', margin: 'auto' }}
		>
			<Grid
				container
				direction="column"
				className={styles['riskmodal-mainheader']}
				data-testid="risk-modal-main-div"
			>
				<Grid
					item
					xs={12}
					lg={12}
					md={12}
					sm={12}
					justifyContent="space-between"
					className={styles['riskmodal-mainheader-grid']}
				>
					<Typography
						className={styles['riskmodal-mainheader-label']}
						data-testid="header"
					>
						{RISK_COUNT_MAIN_LABEL}
					</Typography>
					<CloseIcon
						fontSize="medium"
						onClick={handleModalClose}
						className={styles['riskmodal-btn-close']}
						data-testid="close-icon"
					/>
				</Grid>
				<Grid container mt={1} sx={{ overflow: 'hidden' }}>
					<Grid
						item
						xs={12}
						lg={12}
						md={12}
						sm={12}
						className={styles['riskmodal-img-container']}
					>
						<img
							src={HeatMapScore}
							alt="HeatMap Score"
							className={styles['riskmodal-img-innercontainer']}
						/>
					</Grid>
				</Grid>
				<Grid item direction="column" mt={1.2}>
					<Typography
						className={styles['riskmodal-header-label']}
						data-testid="riskmodal-header-count-label"
					>
						{RISK_COUNT_LABEL}
					</Typography>
					<Typography
						className={styles['riskmodal-header-description']}
						data-testid="riskmodal-header-count-desc"
					>
						{RISK_COUNT_INFO_DESCRIPTION}
					</Typography>
				</Grid>
				<Grid item direction="column" mt={2} xs={12} lg={12} md={12} sm={12}>
					<Typography className={styles['riskmodal-header-label']}>
						{RISK_RECENT_ACTIVITY_LABEL}
					</Typography>
					<Typography className={styles['riskmodal-header-description']}>
						{RISK_RECENT_ACTIVITY_DESCRIPTION}
					</Typography>
				</Grid>
				<Grid item direction="column" mt={2} xs={12} lg={12} md={12} sm={12}>
					<Typography className={styles['riskmodal-header-label']}>
						{RISK_SCORE_CALCULATION_LABEL}
					</Typography>
					<Typography className={styles['riskmodal-header-description']}>
						{RISK_SCORE_CALCULATION_DESCRIPTION}
					</Typography>
				</Grid>
				<Grid
					item
					mt={1}
					className={styles['riskmodal-btn-grid']}
					xs={12}
					lg={12}
					md={12}
					sm={12}
				>
					<Grid item lg={3} alignItems="flex-end">
						<ButtonComp
							btnType="primary"
							data-testid="riskmodal-gotit-btn"
							size="small"
							onClick={handleModalClose}
						>
							{RISK_SCORE_GOT_IT_BUTTON}
						</ButtonComp>
					</Grid>
				</Grid>
			</Grid>
		</ModalEle>
	);
};

export default RiskModal;
